import Block from './Block'
import store from '../util/store'
import gsap from 'gsap'

export default class Contact extends Block {
  getElems() {
    this.arrow = this.el.querySelector('.b-contact__arrow')
    this.button = this.el.querySelector('.e-button')
    this.shape = this.el.querySelector('.b-contact__shape')
  }

  init() {
    if (this.shape) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })

      tl.fromTo(this.shape, {
        yPercent: 50
      }, {
        yPercent: 5
      })
    }
  }

  events() {
    if (this.arrow && this.button) {
      this.arrow.addEventListener('click', () => {
        const tl = gsap.timeline({
          defaults: {
            ease: 'power3.out',
            duration: 0.1
          },
          onComplete: () => {
            this.button.click()
          }
        })

        tl.to(this.arrow, {
          scale: 0.9
        }).to(this.arrow, {
          scale: 1
        })
      })
    }

    this.el.addEventListener('mouseenter', () => {
      store.cursor.addState('-white')
    })

    this.el.addEventListener('mouseleave', () => {
      store.cursor.removeState('-white')
    })
  }
}
